import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { OneSignal } from '@ionic-native/onesignal/ngx';

import { IonicStorageModule } from '@ionic/storage';

import { HttpClientModule } from '@angular/common/http';
//import { Firebase } from '@ionic-native/firebase/ngx'; // not in use anymore
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';

import { InAppBrowser , InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';

import { DataService } from './service/data.service';

import { ImgFallbackModule } from 'ngx-img-fallback';

import { LaunchNavigator } from '@ionic-native/launch-navigator/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';

import { Keyboard } from '@ionic-native/keyboard/ngx';

import { LocalNotifications } from '@ionic-native/local-notifications/ngx';
import { AlertController } from '@ionic/angular';

import { Toast } from '@ionic-native/toast/ngx';

import { Geolocation } from '@ionic-native/geolocation/ngx';

import { SortTitlePipe } from './pipes/sort-title.pipe';
import { SortDatePipe } from './pipes/sort-date.pipe';
import { DateEventStartPipe } from './pipes/date-event-start.pipe';
import { DateEventEndPipe } from './pipes/date-event-end.pipe';
import { DateEventTimeStartPipe } from './pipes/date-event-time-start.pipe';



// USER ONLY // WEBSTRIP
/**
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { firebaseconfig } from './app.firebaseconfig';

import { AuthenticationService } from './profileproviders/authentication-service/authentication-service';
import { UserDetails } from './service/user.details';

import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { ImghandlerProvider } from './profileproviders/imghandler/imghandler';
import { File } from '@ionic-native/file/ngx';
import { Contacts } from '@ionic-native/contacts';
**/



@NgModule({
  declarations: [
    AppComponent
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    ImgFallbackModule/*WEBSTRIP,
    AngularFireModule.initializeApp(firebaseconfig.firebaseConfig), // USER ONLY...
    AngularFireAuthModule, // USER ONLY...
    AngularFireDatabaseModule, // USER ONLY...
    AngularFirestoreModule // USER ONLY...
    */
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    InAppBrowser,
    FirebaseAnalytics,
    // Firebase, // not in use anymore
    OneSignal,
    DataService,
    LaunchNavigator,
    SocialSharing,
    LocalNotifications,
    AlertController,
    Toast,
    Keyboard,
    SortTitlePipe,
    SortDatePipe,
    DateEventStartPipe,
    DateEventEndPipe,
    DateEventTimeStartPipe,
    Geolocation/*WEBSTRIP,
    AngularFirestoreModule,  // USER ONLY...
    UserDetails,
    Camera,
    ImghandlerProvider,
    File,
    Contacts
    */
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
